import { DynamicEnvironment } from './environment.dynamic';

class Environment extends DynamicEnvironment {

  constructor() {
    super();
    this.production = true;
    this.environment_mode = 'prod';
    this.domain_config_gw_api = 'https://capi.yaanimail.com/gateway/v1';
  }
}

export const environment = new Environment();
